import { MapPin, Phone, Clock, ExternalLink } from "lucide-react";

const parlours = [
  {
    id: "main",
    name: "Holiday Ice Creams - Main Plant & Parlour",
    address: "Road No.12, G-23, near Springer School, behind Ramada Hotel, Lachhipur Industrial Area, Dayanand Nagar, Gorakhpur, UP 273015",
    phones: ["9235372759"],
    hours: "Open 24 hours",
    badge: "Flagship",
  },
];

export default function Parlours() {
  return (
    <section className="py-12 md:py-16" data-testid="parlours-page">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-xs tracking-[0.2em] uppercase text-holiday-red font-bold">Our Parlours</p>
        <h1 className="font-display text-5xl md:text-7xl leading-[0.95] mt-3">Find a <span className="text-holiday-red">scoop</span><br/>near you.</h1>

        <div className="mt-12 rounded-[2rem] overflow-hidden cushion border border-[#F0E4E4] bg-white" data-testid="parlour-map">
          <iframe
            title="Holiday Ice Creams - Google Map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3561.3840137482566!2d83.3586991!3d26.795898599999994!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399145006acc60b7%3A0x27c1295a5adbae3d!2sHoliday%20Ice%20Cream!5e0!3m2!1sen!2sin!4v1777113443286!5m2!1sen!2sin"
            width="100%" height="450" style={{ border: 0 }}
            allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"
          />
        </div>

        <div className="mt-12 grid md:grid-cols-2 gap-6">
          {parlours.map((p) => (
            <article key={p.id} className="bg-ice-pink rounded-[2rem] p-7 md:p-8 cushion border border-[#F0E4E4]" data-testid={`parlour-card-${p.id}`}>
              <span className="sticker bg-cream text-choc">{p.badge}</span>
              <h3 className="font-display text-2xl md:text-3xl mt-4">{p.name}</h3>
              <p className="text-sm leading-relaxed text-choc/80 mt-3 flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 shrink-0"/> {p.address}</p>
              <div className="mt-3 flex items-center gap-2 text-sm"><Clock className="w-4 h-4"/> {p.hours}</div>
              <div className="mt-5 flex flex-wrap gap-2">
                {p.phones.map((ph) => (
                  <a key={ph} href={`tel:${ph}`} className="inline-flex items-center gap-1.5 bg-white px-3.5 py-2 rounded-full text-sm font-bold border border-choc/10 hover:bg-holiday-red hover:text-white hover:border-holiday-red transition-colors">
                    <Phone className="w-3.5 h-3.5"/> {ph}
                  </a>
                ))}
                <a href="https://maps.app.goo.gl/xd1he1c7UpNeaTuV9" target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 bg-choc text-cream px-3.5 py-2 rounded-full text-sm font-bold hover:bg-choc/90">
                  <ExternalLink className="w-3.5 h-3.5"/> Directions
                </a>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-14 bg-sun-yellow text-choc rounded-[2rem] p-8 md:p-10 cushion text-center">
          <h2 className="font-display text-3xl md:text-4xl">Want a Holiday parlour in your city?</h2>
          <p className="text-base text-choc/80 mt-2 max-w-xl mx-auto">We're expanding through Eastern UP. Franchise enquiries are open.</p>
          <a href="/grow-with-us" className="inline-flex items-center gap-2 bg-choc text-cream px-7 py-3.5 rounded-full font-bold mt-5">Become a partner</a>
        </div>
      </div>
    </section>
  );
}
